<template>
  <div class="custom-container" v-loading.fullscreen.lock="banner.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="banner-title">Create Banner</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save"
            >Simpan</el-button
          >
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form
          label-position="left"
          ref="formBanner"
          label-width="150px"
          :model="formBanner"
        >
          <Form :Banner="formBanner" from="create"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Form
  },
  data: () => ({
    formBanner: {
      name: "",
      description: "",
      bannerType: "",
      photoUrl: "",
      is_active: true
    },
    valid: true,
    draft: false
  }),
  computed: {
    ...mapState({
      banner: state => state.banner.banner
    })
  },
  methods: {
    ...mapActions({
      createBanner: "banner/CreateBanner"
    }),
    save() {
      this.$refs.formBanner.validate(valid => {
        if (valid) {
          this.createBanner(this.formBanner);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
